import { uniqueId } from 'lodash';
import { createContext, useContext } from 'react';

export type CardContextType = {
  labelId: string;
};

const CardContext = createContext<CardContextType>({
  labelId: uniqueId('card-label-')
});

export const useCardContext = () => useContext(CardContext);
export const CardProvider = CardContext.Provider;